import '@/plugins/vue-qrcode-reader';
import '@/plugins/vue-qriously';
import '@/plugins/vuetify';
import '@/plugins/vue-flag-icon.js';
import '@babel/polyfill';
import VeeValidate from 'vee-validate';
import Vue from 'vue';
import App from './App.vue';
import './plugins/class-component-hooks';
import { Vuelux } from './plugins/vuelux/index';
import './registerServiceWorker';
import Router from './router';
import Store from './store/index';
import { i18n } from '@/plugins/i18n/i18n.ts';
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

Vue.config.productionTip = false;
Vue.use(Vuelux);
Vue.use(VeeValidate);
Vue.use(ElementUI);

new Vue({
  $_veeValidate: {
    validator: 'new'
  },
  router: Router,
  i18n,
  store: Store,
  render: (h) => h(App),
}).$mount('#app');
